module.exports = __webpack_public_path__ + "static/right-687c87029c6e8963675223f2fa9e5224.png";